export default "__VITE_ASSET__ba287aeb__"